import clientFetcher from '@finance/clientFetcher';
import { Document } from 'fluent-graphql';
import type { Currency, Errors, TypedObject } from '../types';

export interface UpdateCurrencyReturn {
  updateCurrency: Currency | { name: string } & TypedObject | Errors;
}

interface UpdateCurrencyVars {
  organizationId: string;
  currencyId: string;
  input: unknown;
}

export default Document
  .mutation<UpdateCurrencyReturn, UpdateCurrencyVars>('UpdateCurrency')
    .variableDefinitions({ organizationId: 'ID!', currencyId: 'ID!', input: 'CurrencyInput!' })
    .union('updateCurrency')
      .useVariables({ organizationId: 'organizationId',  currencyId: 'currencyId', input: 'input' })
      .onEntity('Currency')
        .scalar('name')
        .scalar('code')
        .scalar('precision')
        .scalar('archived')
        .scalar('isDefault')
        .scalar('organizationId')._
      .onTypedObject('NameAlreadyUsed')
        .scalar('name')._
      .onTypedObject('InputErrors')
        .scalar('errors')._._._
  .makeExecutable(clientFetcher);
